import clsx from 'clsx';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { useMemo } from 'react';
import { FC } from 'react';
import React from 'react';
import { ReactPaginateProps } from 'react-paginate';
import ReactPagination from 'react-paginate';
import styles from './Pagination.module.scss';
import { SvgIcon } from './SvgIcon';

const ArrowLeft = () => (
    <SvgIcon width={8} height={14} noFill>
        <path d="M7 1 1 7l6 6" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
);

const ArrowRight = () => (
    <SvgIcon width={8} height={14} noFill>
        <path d="m1 13 6-6-6-6" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
);

export interface Props {
    page: number;
    limit: number;
    total: number;
    onChange: (nextPage: number) => void;
}

const usePaginationHrefBuilder = () => {
    const router = useRouter();

    const baseSearchParams = useMemo(() => {
        const searchParams = router.asPath.replace(/^[^?]*\?/, '');
        return new URLSearchParams(searchParams);
    }, [router.asPath]);

    return useCallback(
        (page) => {
            baseSearchParams.set('page', String(page));
            return router.pathname + '?' + baseSearchParams.toString();
        },
        [baseSearchParams, router.pathname]
    );
};

export const Pagination: FC<Props> = ({ page, limit, total, onChange }) => {
    const totalPages = Math.ceil(total / limit) || 0;

    const handleChange: ReactPaginateProps['onPageChange'] = ({ selected }) => {
        onChange(selected + 1);
    };

    const hrefBuilder = usePaginationHrefBuilder();

    return (
        <ReactPagination
            forcePage={page - 1}
            pageCount={totalPages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={4}
            onPageChange={handleChange}
            containerClassName={styles.pagination}
            activeClassName={styles.active}
            pageClassName={styles.item}
            breakClassName={styles.item}
            pageLinkClassName={styles.link}
            previousClassName={clsx(
                styles.arrow,
                styles.nav,
                styles.prev,
                page === 1 && styles.hidden
            )}
            previousLinkClassName={styles.link}
            nextClassName={clsx(
                styles.arrow,
                styles.nav,
                styles.next,
                page === totalPages && styles.hidden
            )}
            nextLinkClassName={styles.link}
            previousLabel={<ArrowLeft />}
            nextLabel={<ArrowRight />}
            hrefBuilder={hrefBuilder}
        />
    );
};

export default Pagination;
